import { connectToDatabase } from "@/components/Server/Database/MongoDB";
import StudentDashboardLayout from "@/components/Student/DashboardLayout";
import Wishlist from "@/components/Student/Wishlist";
import PageHead from "@/pages/Head";

const StudentWishlist = ({ info }) => {
  return (
    <>
      <PageHead title="Student Wishlist Course - Online Courses & Education Powered By THEWEBVALE" />
      <StudentDashboardLayout brand={JSON.parse(info)} sidebar>
        <Wishlist />
      </StudentDashboardLayout>
    </>
  );
};

export const getServerSideProps = async (context) => {
  const domainName = context.req ? context.req.headers.host : null;

  const { db } = await connectToDatabase();

  const info = await db.collection("partners").findOne({
    key: process.env.DEFAULT || domainName,
  });

  if (!info) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      info: JSON.stringify(info),
    },
  };
};

export default StudentWishlist;
